/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Uno_Hints_Enabled_DescInputs */



/**
* | output |
* | --- |
* | "Uno's ambient education hints are now shown to members." |
*
* @param {Audit_Details_Uno_Hints_Enabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_uno_hints_enabled_desc = /** @type {((inputs?: Audit_Details_Uno_Hints_Enabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Uno_Hints_Enabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die begleitenden Lernhinweise von Uno werden den Mitgliedern jetzt angezeigt.")
	return /** @type {LocalizedString} */ ("Uno's ambient education hints are now shown to members.")
});